import React from "react";

import { ErrorRounded } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { customAlphabet } from "nanoid";
import { useNavigate } from "react-router-dom";

import useModal from "../../config/context/modalContext";
import { CodeService } from "../../config/services/CodeService";
import { Dev } from "../../config/util/consoleUtil";

import MainBorderButton from "../../components/MainBorderButton";
import MainText from "../../components/MainText";

import { ReactComponent as ReactLogo } from "../../assets/images/logo.svg";

export default function CodePage() {
  const navigate = useNavigate();

  const { pushAlert } = useModal();

  const CodeCreate = CodeService.Create();
  const nanoid = customAlphabet("ABCDEFGHJKLMNPQRSTUVWXYZ123456789", 6);

  const [authCode, setAuthCode] = React.useState<string | null>();
  const [loading, setLoading] = React.useState(false);

  const handleGenerateCode = async () => {
    try {
      setLoading(true);

      const urlParams = window.location.href;

      if (!urlParams) {
        pushAlert({
          type: "error",
          message: "Nenhuma chave foi encontrada",
        });
        return;
      }

      const dateNow = new Date();

      const queryParameters = new URLSearchParams(window.location.search);
      const email = queryParameters.get("email");

      if (!email) {
        pushAlert({
          type: "error",
          message: "Nenhuma chave foi encontrada",
        });
        return;
      }

      const generatedCode = nanoid();

      const created = await CodeCreate.runRequest({
        code: generatedCode,
        createdAtISO: dateNow.toISOString(),
        createdAtTimestamp: dateNow.getTime(),
        path: urlParams,
        email,
      });

      if (!created) throw new Error();

      setAuthCode(generatedCode);
    } catch (error) {
      console.log(...new Dev("handlegenerateCode", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao gerar código",
      });
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(authCode ?? "");
      pushAlert({
        type: "error",
        message: "Código copiado!",
      });
    } catch (error) {
      console.log(...new Dev("copyToClipboard", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao copiar código!",
      });
    }
  };

  React.useEffect(() => {
    handleGenerateCode();
  }, []);

  return (
    <Box
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        width={"90%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <Box
          sx={{
            width: "150px",
            height: "150px",
          }}
        >
          <ReactLogo style={{ width: "100%", height: "100%" }} />
        </Box>

        <Box py={1}>
          <MainText size="subtitle">Circular UFRN</MainText>
        </Box>

        <MainText size="caption" color="regular">
          Código de Login:
        </MainText>

        <Box py={4}>
          {loading ? (
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
              <Skeleton
                animation="wave"
                variant="rounded"
                width={"190px"}
                height={60}
                sx={{ mb: 2, borderRadius: "15px", margin: "0px 4px" }}
              />
            </Box>
          ) : authCode ? (
            <MainText size="title">{String(authCode)?.split("").join(" ")}</MainText>
          ) : (
            <ErrorRounded style={{ fontSize: 40 }} color={"error"} />
          )}
        </Box>

        {loading ? (
          <Skeleton
            animation="wave"
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ mb: 2, borderRadius: "15px", margin: "0px 4px" }}
          />
        ) : authCode ? (
          <MainBorderButton onClick={copyToClipboard} text="Copiar Código" />
        ) : null}

        <Box my={2} width={"100%"}>
          <MainBorderButton text="Sair" onClick={() => navigate("/")} />
        </Box>
      </Box>
    </Box>
  );
}
